const categoriesData = {
  categories: [
    {
      id: "category1",
      name: "Stocks",
    },
    {
      id: "category2",
      name: "Mutual Funds",
    },
    {
      id: "category3",
      name: "Personal Finance",
    },
    {
      id: "category4",
      name: "PPF - NPS",
    },
    {
      id: "category5",
      name: "Miscellaneous",
    },
  ],
};
export default categoriesData;
